module.exports = __webpack_public_path__ + "img/robot.48a2c00e.png";